module.exports = __webpack_public_path__ + "img/email-configuration-info.647ac62b.jpeg";